import { Button } from "@fronterahealth/frontera-ui-components/ui/button";
import { Spinner } from "@fronterahealth/frontera-ui-components/ui/spinner";

import { useOpenFinishReview } from "@components/ReportReview/hooks/useFinishReview";
import { useReviewStatus } from "@components/ReportReview/hooks/useReviewStatus";

export const FinishReviewButton: React.FC = () => {
  const { isPending } = useReviewStatus();
  const openFinishReview = useOpenFinishReview();

  return (
    <Button size="sm" disabled={isPending || !openFinishReview} onClick={() => openFinishReview?.()}>
      {isPending && <Spinner />}
      Finish review
    </Button>
  );
};
